import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveAdoptedCodeBookMutationVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
  codeBookId: Types.Scalars['uuid']['input'];
}>;


export type RemoveAdoptedCodeBookMutation = { __typename?: 'mutation_root', delete_jurisdiction_adopted_codes_by_pk?: { __typename?: 'jurisdiction_adopted_codes', jurisdiction_id: any, code_book_id: any } | null };


export const RemoveAdoptedCodeBookDocument = gql`
    mutation removeAdoptedCodeBook($jurisdictionId: uuid!, $codeBookId: uuid!) {
  delete_jurisdiction_adopted_codes_by_pk(
    jurisdiction_id: $jurisdictionId
    code_book_id: $codeBookId
  ) {
    jurisdiction_id
    code_book_id
  }
}
    `;
export type RemoveAdoptedCodeBookMutationFn = Apollo.MutationFunction<RemoveAdoptedCodeBookMutation, RemoveAdoptedCodeBookMutationVariables>;

/**
 * __useRemoveAdoptedCodeBookMutation__
 *
 * To run a mutation, you first call `useRemoveAdoptedCodeBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdoptedCodeBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdoptedCodeBookMutation, { data, loading, error }] = useRemoveAdoptedCodeBookMutation({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *      codeBookId: // value for 'codeBookId'
 *   },
 * });
 */
export function useRemoveAdoptedCodeBookMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAdoptedCodeBookMutation, RemoveAdoptedCodeBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAdoptedCodeBookMutation, RemoveAdoptedCodeBookMutationVariables>(RemoveAdoptedCodeBookDocument, options);
      }
export type RemoveAdoptedCodeBookMutationHookResult = ReturnType<typeof useRemoveAdoptedCodeBookMutation>;
export type RemoveAdoptedCodeBookMutationResult = Apollo.MutationResult<RemoveAdoptedCodeBookMutation>;
export type RemoveAdoptedCodeBookMutationOptions = Apollo.BaseMutationOptions<RemoveAdoptedCodeBookMutation, RemoveAdoptedCodeBookMutationVariables>;